// sagas.js
import { all, call, fork, put, takeLatest } from 'redux-saga/effects';
import { fetchEmployeeApi } from '../../helpers/fakebackend_helper';
import { FETCH_EMPLOYEES_REQUEST } from './actionType';
import { fetchEmployeesFailure, fetchEmployeesSuccess } from './action';

function* fetchEmployeesSaga() {
    try {
        const response = yield call(fetchEmployeeApi);
        if (response.success && response.success === true) {
            const employees = response.data;
            yield put(fetchEmployeesSuccess(employees));
        }
    } catch (error) {
        yield put(fetchEmployeesFailure(error.message));
    }
}

export function* watchEmployeeSaga() {
    yield takeLatest(FETCH_EMPLOYEES_REQUEST, fetchEmployeesSaga);
}



function* authFetchEmployeeSaga() {
    yield all([
        fork(watchEmployeeSaga),
    ]);
}

export default authFetchEmployeeSaga;





